import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../interfaces/IIcon";

export const GreenAreasIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M8.942 5.214a1.578 1.578 0 0 0-1.42-1.57 2.421 2.421 0 0 0-4.822-.43 2.111 2.111 0 0 0 .123 4.16V9h.53V7.381a2.108 2.108 0 0 0 1.492-.895V9h.53V5.827a2.37 2.37 0 0 0 .498-.106 1.582 1.582 0 0 0 1.226 1.047V9h.53V6.768a1.578 1.578 0 0 0 1.313-1.554ZM3.354 6.817V4.75h-.531v.858L2.416 5.2l-.375.374.782.783v.452a1.558 1.558 0 1 1 .53.008Zm2.021-2.55.796-.796-.375-.375-.42.42v-.868h-.53v1.435a2.107 2.107 0 0 0-1.557-.895 1.839 1.839 0 1 1 3.639.516A1.578 1.578 0 0 0 5.789 5.13a1.856 1.856 0 0 1-.414.11v-.973ZM7.63 6.299V6.1l.712-.713-.375-.374-.337.337v-.597h-.53v1.546a1.057 1.057 0 1 1 .53 0Z" />
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../interfaces/IIcon";

export const GreenAreasIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M8.942 5.214a1.578 1.578 0 0 0-1.42-1.57 2.421 2.421 0 0 0-4.822-.43 2.111 2.111 0 0 0 .123 4.16V9h.53V7.381a2.108 2.108 0 0 0 1.492-.895V9h.53V5.827a2.37 2.37 0 0 0 .498-.106 1.582 1.582 0 0 0 1.226 1.047V9h.53V6.768a1.578 1.578 0 0 0 1.313-1.554ZM3.354 6.817V4.75h-.531v.858L2.416 5.2l-.375.374.782.783v.452a1.558 1.558 0 1 1 .53.008Zm2.021-2.55.796-.796-.375-.375-.42.42v-.868h-.53v1.435a2.107 2.107 0 0 0-1.557-.895 1.839 1.839 0 1 1 3.639.516A1.578 1.578 0 0 0 5.789 5.13a1.856 1.856 0 0 1-.414.11v-.973ZM7.63 6.299V6.1l.712-.713-.375-.374-.337.337v-.597h-.53v1.546a1.057 1.057 0 1 1 .53 0Z" />
        </SvgIcon>
    );
};
